<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <!-- <div class="model">
        <p>{{ this.$store.getters.USER.selectedMarketingVoucher.name }}</p>
      </div>
      <div class="model">
        <p>{{ this.$store.getters.USER.selectedMarketingVoucher.discountType }}</p>
      </div>
      <div class="model">
        <p>{{ this.$store.getters.USER.selectedMarketingVoucher.discountAmount }}</p>
      </div>
      <div class="model">
        <p>{{ this.$store.getters.USER.selectedMarketingVoucher.expiration || 'No expiration' }}</p>
      </div>-->
      <img :src="logoIcon" class="logo" />
      <div class="info">
        <p>
          {{ this.$store.getters.TRANSLATIONS["expiry_date"] }}
          {{
            this.$store.getters.USER.selectedMarketingVoucher.expiration ||
            "No expiration"
          }}
        </p>
        <barcode
          v-if="code"
          v-model="code"
          class="barcode"
          :options="{ displayValue: true }"
        ></barcode>
      </div>
    </div>
    <!-- <div class="footer" v-if="!loading">
      <button v-on:click="remove()" class="button remove">REMOVE</button>
    </div>-->
    <v-dialog style="margin-top: 25%; text-align: center" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      logoIcon: require("@/assets/new_design/Parkenda_VerticalLogo_FullColour.png"),
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      cards: [],
      code: this.$store.getters.USER.selectedMarketingVoucher.code,
      cardIcon: require("@/assets/cardIcon.png"),
      back: () => {
        this.$router.push("/marketCampagnsList");
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.barcode {
}
.logo {
  width: 25%;
  margin: 0 auto;
}

.info {
  border: 1px solid #fbae31;
  border-radius: 25px;
  margin: 20vh 10vw 0;
  padding: 15px;
}
.info p {
  color: white;
  padding: 10px;
}
.barcode {
  width: 70%;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/MarketingCampaignVouchers/Edit.vue